module.exports = __webpack_public_path__ + "static/media/motorcycle.9c9516ec.svg";